/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (layoutId, layout) => ({
	type: actions.EDIT_DASHBOARD_LAYOUT,
	payload: {
		id: layoutId,
		layout,
	},
});
